import React, { Component } from 'react';
import CountUp from 'react-countup';
import TitulinAgr from './Titulin';
import { jsUcfirst } from '../utils/helpers';

export default class CabeceraGrupo extends Component {
	constructor() {
		super();
		this.state = {
			idePos: 0,
			rank: 0
		};
		// BINDINGS
	}
	//END CONSTRUCTOR

	componentWillMount() {
		if (this.props.agrupaciones) {
			// Filtra tipo y ordena
			const agrVisible = Object.keys(this.props.agrupaciones)

				.filter(key =>
					this.props.agrupaciones[key].cat.includes(
						this.props.agrupaciones[this.props.ide].cat
					)
				)
				.filter(
					key => this.props.agrupaciones[key][`${this.props.fase}tot`] > 0
				)
				.sort(
					(a, b) =>
						this.props.agrupaciones[a][`${this.props.fase}tot`] >
						this.props.agrupaciones[b][`${this.props.fase}tot`]
							? -1
							: 1
				);

			const rankNums = agrVisible.map(
				key => this.props.agrupaciones[key][`${this.props.fase}tot`]
			);

			// rankPosicion Devuelve ranking
			let count = 0;
			const rankPosicion = rankNums.map((x, i) => {
				if (rankNums[i] === rankNums[i - 1]) {
					return count;
				}
				count += 1;
				return count;
			});

			let indexRank = agrVisible.indexOf(this.props.ide);
			let rank = rankPosicion[indexRank];

			this.setState({
				rank: rank
			});
		}
	}
	render() {
		const elegida = this.props.agrupaciones[this.props.ide];

		return (
			<div className="cabeceraGrupo">
				<div>
					<TitulinAgr
						titulo={jsUcfirst(elegida.cat)}
						rank={this.state.rank === 1 ? true : false}
						color={this.props.mainColor}
					/>
					<h1 className="nombre_agrupacion">{elegida ? elegida.nom : ''}</h1>
				</div>
				<div className="data">
					<ul className="contPuntos">
						<li className="puntosTotal" style={{ color: this.props.mainColor }}>
							<CountUp
								start={0}
								end={
									this.props.agrupaciones[this.props.ide][
										`${this.props.fase}tot`
									]
								}
							/>
						</li>
						<li className="spanPuntos">puntos</li>
					</ul>
					<ul className="contRanking">
						<li className="ranking" style={{ color: this.props.mainColor }}>
							<CountUp
								suffix={this.state.rank ? 'º' : ''}
								start={this.state.rank ? 56 : 0}
								end={this.state.rank ? this.state.rank : 0}
							/>
						</li>
						<li className="spanRanking">Ranking</li>
					</ul>
				</div>
				<div className="metadata">
					<h2 className="localidad">{elegida ? elegida.loc : ''}</h2>
					<ul>
						<li>
							<strong> En 2017:</strong> {elegida ? elegida.en17 : ''}
						</li>
						<li>
							<strong> Música: </strong>
							{elegida ? elegida.mus : ''}
						</li>
						<li>
							<strong> Letra: </strong>
							{elegida ? elegida.ler : ''}
						</li>
						<li>
							<strong> Director: </strong>
							{elegida ? elegida.dire : ''}
						</li>
					</ul>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CabeceraGrupo.js